export default __webpack_public_path__ + "static/144-d73e920499a43ac7ad5105c1b71c7949.jpg";